module.exports = __webpack_public_path__ + "media/images/mypage/icon/blue/ico_help-7b4e497e0701c8c90b30e59b6564fdb0.svg";